var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticStyle:{"text-overflow":"ellipsis","overflow":"hidden","white-space":"nowrap","max-width":"200px"}},[(_vm.eventName)?_c('span',[_vm._v(_vm._s(this.eventName))]):_c('v-skeleton-loader',{attrs:{"type":"text","width":"100px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }